import { setImpersonationToken } from '@repletoryreach/sdk-api';

const HASH_PREFIX = '#impersonation=';

/**
 * W31: call once before mounting the app. If the URL carries an impersonation
 * token in the hash fragment (`#impersonation=<jwt>`, as opened by the admin
 * console), adopt it into tab-scoped sessionStorage and scrub the fragment from
 * the address bar + history so the token never lingers in the URL. The hash
 * fragment is used precisely because it is never sent to any server or logged
 * in access logs. Returns true when a token was captured.
 */
export function captureImpersonationFromUrl(): boolean {
  if (typeof window === 'undefined') return false;
  const hash = window.location.hash;
  if (!hash.startsWith(HASH_PREFIX)) return false;
  const token = decodeURIComponent(hash.slice(HASH_PREFIX.length));
  if (!token) return false;
  setImpersonationToken(token);
  window.history.replaceState(null, '', window.location.pathname + window.location.search);
  return true;
}
